import React, { useCallback, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Wrapper from 'components/reusables/wrapper'
import Table from './components/table/Table'
import { Description, RankmiTableWrapper, Title } from './styled'

const MIN_SEARCH_LENGTH = 3

const Hierarchy: React.FC = () => {
  const { t } = useTranslation()
  const bounceId = useRef(0)

  const [searchText, setSearchText] = useState('')

  const handleSearch = useCallback((value: any) => {
    if (bounceId.current) {
      clearTimeout(bounceId.current)
    }
    if (value.length >= MIN_SEARCH_LENGTH || !value.length) {
      bounceId.current = window.setTimeout(() => {
        setSearchText(value.trim())
      }, 1000)
    }
  }, [])

  return (
    <Wrapper shadow={true}>
      <Title>{t('configuration.hierarchy.title')}</Title>
      <Description>{t('configuration.hierarchy.subtitle')}</Description>
      <RankmiTableWrapper>
        <Table searchText={searchText} handleSearch={handleSearch} />
      </RankmiTableWrapper>
    </Wrapper>
  )
}

export default Hierarchy
